import {
  IsArray,
  IsEmail,
  IsNotEmpty,
  IsOptional,
  IsString,
  Length,
  Matches,
} from 'class-validator';
import { IBase, IShop, IUser } from '../interfaces';
import { MongodbRelationId } from './utils.dto';
import { Type } from 'class-transformer';
import { IRole } from '@tickeat/permissions';

export class UserDTO
  implements Omit<IUser, keyof IBase | 'password' | 'organization' | 'deletedAt'>
{
  @IsNotEmpty({ message: 'Le prénom est requis' })
  firstname: string;

  @IsNotEmpty({ message: 'Le nom est requis' })
  lastname: string;

  @IsNotEmpty({ message: "L'email est requis" })
  @IsEmail(undefined, { message: "Le format de l'email est incorrect" })
  email: string;

  @IsNotEmpty({ message: 'Le téléphone est requis' })
  @IsString({ message: 'Le téléphone doit être une chaîne de caractères' })
  @Matches(/^0\d{9}$/, { message: 'Le format du téléphone est incorrect' })
  phone: string;

  @IsOptional()
  @IsArray({ message: 'Le format de données est inccorect' })
  @Type(() => MongodbRelationId)
  shops: Pick<IShop, '_id'>[];

  @IsOptional()
  @IsString({ message: 'Le code est requis' })
  @Length(4, 4, { message: 'Le code doit contenir 4 chiffres' })
  @Matches(/^\d{4}$/, { message: 'Le code doit contenir uniquement des chiffres' })
  code: string;

  @IsOptional()
  @IsArray({ message: 'Le format de données est inccorect' })
  // @Type(() => MongodbRelationId)
  roles: IRole[];

  @IsOptional()
  deletedAt: Date | null;
}
